module.exports = __webpack_public_path__ + "static/media/facebooksc.91631b2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/facebooksc.svg
// module id = 359
// module chunks = 25